// extracted by mini-css-extract-plugin
export default {"sticky":"LandingPage_sticky__xmLbE","sectionTitle":"LandingPage_sectionTitle__Fjdgf h2","sectionSubHeading":"LandingPage_sectionSubHeading__mFOVu sectionSubHeading"};